import SchoolLogo from "../assets/images/ozoro.png";

export const InstitutionName = "Southern Delta University, Ozoro";
export const AffiliateName = "";

export { SchoolLogo };

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const currentSession = "2026/2027";

export const X_SCHOOL_CODE = "ozoro";

export const sessionList = [
  "2019/2020",
  "2020/2021",
  "2021/2022",
  "2022/2023",
  "2023/2024",
  "2024/2025",
  "2025/2026",
  "2026/2027",
];

export const currencyFormatter = (value) => {
  return Number(value)?.toLocaleString("en-NG", { style: "currency", currency: "NGN" });
};

export const paymentTypes = [
  {
    name: "School Fees - Full Payment",
    key: "full_payment",
  },
  {
    name: "School Fees - First Instalment",
    key: "part_payment",
  },
  {
    name: "School Fees - Second Instalment",
    key: "second_installment",
  },
  {
    name: "Late Payment",
    key: "late_payment",
  },
  {
    name: "Final Clearance Fee",
    key: "FINAL_CLEARANCE",
  },
  {
    name: "GST Handbook",
    key: "GST_HANDBOOK",
  },
  {
    name: "CEED Training Manual",
    key: "CEED",
  },
  {
    name: "Additional Fee (**This is for those who need to balance their fees**)",
    key: "additional_fee",
  },
  {
    name: "Medical Fee",
    key: "MEDICAL",
  },
  {
    name: "HND CONVERSION",
    key: "HND_CONVERSION",
  },
  {
    name: "Laboratory Coat",
    key: "LABORATORY_COAT",
  },
];

export const OTHER_FEE_OPTIONS = [
  "MEDICAL",
  "FINAL_CLEARANCE",
  "GST_HANDBOOK",
  "CEED",
  "HND_CONVERSION",
  "LABORATORY_COAT"

];

export const errorProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  export const warnProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  export const successProp = {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };
